import Vue from 'vue'
import wfTip from './index.vue'
let init = (options) => {
  let messageInstance = new (Vue.extend(wfTip))({
    el: document.createElement('div'),
  })
  messageInstance.config = Object.assign(messageInstance.config, options)
  messageInstance.$mount()
  document.body.appendChild(messageInstance.$el)
  return messageInstance
}

let caller = ({ title, content, confirm = '知道了', contentClick }) => {
  return new Promise((resolve, reject) => {
    let params = { title, content, confirm, contentClick }
    for (let key in params) {
      if (!params[key]) {
        delete params[key]
      }
    }
    let messageInstance = init(params)
    messageInstance.open()
    messageInstance.check = () => {
      messageInstance.close()
      resolve()
    }
  })
}

export default {
  install(vue) {
    vue.prototype.$wfTip = caller
    Vue.component(wfTip.name, wfTip)
  }
}
